<template>
<v-card-text>
  <v-form ref="personalizationForm">
    <v-card-text>
        <v-container grid-list-md mt-12>
            <v-layout wrap>
              <v-flex xs12 sm6 md3>
                <span>Allow personalization</span>
                <v-radio-group
                    v-model="productObject.enable_personalization"
                >
                <v-radio
                    label="Yes"
                    value="yes"
                ></v-radio>
                <v-radio
                    label="No"
                    value="no"
                ></v-radio>
                <v-radio
                    label="Digital product"
                    value="digital"
                ></v-radio>
            </v-radio-group>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <span>Product Type</span>
                <v-radio-group
                    v-model="productObject.engraving_type"
                >
                  <v-radio
                      label="Wood"
                      value="wood"
                  ></v-radio>
                  <v-radio
                      label="Leather"
                      value="leather"
                  ></v-radio>
                  <v-radio
                      label="Glass"
                      value="glass"
                  ></v-radio>
                  <v-radio
                      label="Metal"
                      value="metal"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <span>Type of personalization</span>
                <v-radio-group
                    v-model="productObject.personalization_type"
                >
                  <v-radio
                      label="Text"
                      v-bind:value="'text'"
                  ></v-radio>
                  <v-radio
                      label="Picture"
                      v-bind:value="'picture'"
                  ></v-radio>
                  <v-radio
                      label="Picture and text"
                      v-bind:value="'text,picture'"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="productObject.enable_personalization === 'yes'">
                <span>Is image upload available</span>
                <v-radio-group
                    v-model="productObject.customer_design_upload_enabled"
                >
                  <v-radio
                      v-bind:value="false"
                      label="Yes"
                  ></v-radio>
                  <v-radio
                      v-bind:value="true"
                      label="No"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-layout wrap>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3>
                    <h6>Different product options</h6>
                    <v-text-field
                        v-model="optionName"
                        :label="$t('product.groupOptionName')"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="create-option-button">
                    <v-btn style="margin-right: 5px" @click="createOption()">Create an option</v-btn>
                  </v-flex>
                  <fieldset :key="groupName" v-for="groupName in getGroupNames()">
                    <div class="option-title">
                      <h5>{{ groupName }}</h5>
                      <v-btn @click="createGroupOption(groupName)">+</v-btn>
                    </div>
                    <v-flex xs12 sm6 md12 :key="index" v-for="(variant, index) in productObject.variants">
                      <v-row v-if="variant.group_name === groupName">
                        <v-col v-if="$route.params.id" sm="2">
                          <v-btn color="error" @click="deleteOption(variant)" class="add-button ml-1">Remove</v-btn>
                        </v-col>
                        <v-col sm="3">
                          <v-text-field
                              v-model="variant.title"
                              :label="$t('product.option.name')"
                              :placeholder="$t('product.option.name')"
                          />
                        </v-col>
                        <v-col sm="1">
                          <v-text-field
                              v-model="variant.prices[0].value"
                              :label="$t('product.option.price')"
                              :placeholder="$t('product.option.price')"
                          />
                        </v-col>
                        <v-col sm="2">
                          <v-select
                              v-model="variant.prices[0].currency"
                              :items="currency"
                              :placeholder="$t('product.currency')"
                              :label="$t('product.currency')"
                              return-object
                              item-text="value"
                              item-value="id"
                          ></v-select>
                        </v-col>
                        <v-col sm="3">
                          <img class="image" v-bind:src="getImageUrl(variant.image)">
                          <div class="row mt-1">
                            <i class="mdi mdi-delete delete delete-sign-product image"  title="delete" @click="removeImage(variant, variant.image)"></i>
                            <input v-if="!variant.image" @change="setImage(variant, 'image', $event)" id="image" type='file' accept="image/*"/>
                          </div>
                        </v-col>
                      </v-row>
                    </v-flex>
                  </fieldset>
                </v-layout>
                <v-flex xs12 sm6 md12 v-if="productObject.enable_personalization === 'yes'">
                  <h6>Add a picture for the presentation</h6><br>
                  <v-row>
                    <v-col sm="3">
                      <input @change="setPersonalizationImage()" id="image-personalization" type='file' accept="image/*"/>
                    </v-col>
                    <v-col sm="2">
                      <v-btn :disabled="!imagePreview" @click="triggerMarker">Add a printable area</v-btn>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex xs12 sm6 md12 v-if="productObject.enable_personalization === 'yes'">
                  <v-row sm="6">
                    <v-col sm="6">
                      <br><br>
                      <h6 v-show="productObject.customer_design_upload_enabled">Choose a product design</h6><br>
                      <v-data-table
                          :headers="headersDesign"
                          :items="getAllProductDesigns"
                          :rows-per-page-items ="rowsAmount"
                          :search="searchDesigns"
                          class="elevation-1 table-scroll"
                          v-show="productObject.customer_design_upload_enabled"
                          show-select
                          v-model="productObject.designs"
                      >
                        <template v-slot:item.image="{ item }">
                          <td>
                            <div v-if="item.image">
                               <v-img class="table-image" v-bind:src=item.image></v-img>
                            </div>
                            <div v-else>---</div>
                          </td>
                        </template>
                      </v-data-table>
                      <br><br><h6>Choose fonts</h6><br>
                      <v-data-table
                          :headers="headersFonts"
                          :items="getAllFonts"
                          :rows-per-page-items ="rowsAmount"
                          :search="searchFonts"
                          class="elevation-1 table-scroll"
                      >
                        <template v-slot:item="props">
                          <tr>
                            <th>
                              <v-checkbox
                                  v-model="productObject.font_ids_enabled"
                                  primary
                                  hide-details
                                  v-bind:value="props.item.id"
                              ></v-checkbox>
                            </th>
                            <td>
                              <div>{{ props.item.name }}</div>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-col>
                    <v-col sm="6" v-show="productObject.customer_design_upload_enabled">
                      <cropper
                          v-show="showMarker"
                          ref="cropper"
                          id="uploadedPersonalization"
                          class="cropper"
                          :src="imagePreview"
                          @change="cropperChange"/>
                      <div v-if="!showMarker" class="image-preview-container">
                        <img class="image-preview" :src="imagePreview">
                      </div>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-layout>
        </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                class="add-new mb-1 mt-8 mr-3" dark
                @click="cancelPersonalization()">{{ $t('cancel')}}</v-btn>
            <v-btn
                class="add-new mb-1 mt-8 mr-3"
                dark
                @click="createPersonalization()">{{ $t('submit')}}</v-btn>
        </v-card-actions>
  </v-form>
 </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex'
import i18n from '../../i18n'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

export default {
    components: {
      Cropper
    },
    data () {
          return {
              imagePreview: null,
              showMarker: false,
              coordinates: {
                width: 0,
                height: 0,
                left: 0,
                top: 0,
              },
              imageSize: {
                height: null,
                width: null
              },
              currency: ['RSD', 'EUR'],
              productObject: {
                enable_personalization: 'yes',
                engraving_type: 'wood',
                personalization_type: 'text',
                customer_design_upload_enabled: true,
                font_ids_enabled: [],
                designs: [],
                design_ids: [],
                variants: [],
                printing_area_top: null,
                printing_area_left: null,
                printing_area_width: null,
                printing_area_height: null,
                printing_image: null,
                printing_image_width: null,
                printing_image_height: null

              },
              selectedCurrency: '',
              items: [ i18n.t('product.information'), i18n.t('product.personalization')],
              radiosUploadImage: true,
              radioTypeOfPersonalization: '',
              engraving_type: 'wood',
              optionName: '',
              optionNameText: '',
              priceOption: '',
              searchFonts: '',
              searchDesigns: '',
              selectedFonts: [],
              selectedDesigns: [],
              rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
              headersFonts: [
                { text: i18n.t(''),},
                { text: i18n.t('mobile.fontName'), value: 'name'},
              ],
              headersDesign: [
                { text: i18n.t('mobile.titleDesign'), value: 'title'},
                { text: i18n.t('mobile.image'), value: 'image'},
            ],
          }
    },
    props: {
      product: {
        type: Object
      }
    },
    computed:{
        ...mapGetters([
            'getAllProductDesigns',
            'getAllFonts'
        ])
    },
    methods:{
      triggerMarker () {
        this.showMarker = true
        this.$nextTick(() => this.$refs.cropper.refresh());
      },
      cropperChange ({ coordinates, image }) {
        this.coordinates = coordinates;
        this.productObject.printing_area_top = coordinates.top
        this.productObject.printing_area_left = coordinates.left
        this.productObject.printing_area_width = coordinates.width
        this.productObject.printing_area_height = coordinates.height
        this.productObject.printing_image_height = image.height
        this.productObject.printing_image_width = image.width
      },
      getImageUrl: function (image) {
        if (typeof image === 'string') {
          return image
        }

        if (image instanceof File) {
          return URL.createObjectURL(image)
        }

        return ''
      },
        getGroupNames: function() {
          if (!this.productObject.variants) {
            return []
          }

          return this.productObject.variants.map(obj => obj.group_name).filter((v,i,s) => s.indexOf(v) === i)
        },
        createOption() {
        if(this.optionName) {
          this.productObject.variants.push({
            group_name: this.optionName,
            title: '',
            product_id: 0,
            image: '',
            prices: [
              {
                value: 0,
                currency: "EUR"
              },
            ]
          })
          this.optionName = null
          }
        },
      deleteOption(selectedVariant) {
        this.productObject.variants = this.productObject.variants.filter(variant =>  {
          return variant.id !== selectedVariant.id
        })
      },
        createGroupOption(groupName) {
          this.productObject.variants.push({
            group_name: groupName,
            title: '',
            product_id: 0,
            image: '',
            prices: [
              {
              value: 0,
              currency: "EUR"
            },
            ]
          })
      },
        setPersonalizationImage(){
          const image = document.getElementById('image-personalization').files[0];
          this.productObject.printing_image = image
          this.imagePreview = window.URL.createObjectURL(image);
        },
        setImage(target, attribute, event) {

          this.$store.dispatch('CREATE_FILE', event.target.files[0])
              .then((e) => {
                target[attribute] = e.data.data.url
              })
        },
        removeImage(selectedVariant){
          this.productObject.variants.filter(variant =>  {
            if(variant.title === selectedVariant.title) {
              variant.image = null
            }
          })
        },
        cancelPersonalization(){
        // this.resetProductsForm();
            this.$router.push(`/${i18n.locale}/products`);
        },
        getSeletctedFonts(lang){
          let index;
            if ((index = this.selectedFonts.indexOf(lang)) === -1) {
              this.selectedFonts.push(lang)
            } else {
              this.selectedFonts.splice(index, 1)
            }
        },

        createPersonalization(){
          this.$emit('createPersonalization')
        },
    },
     beforeCreate() {
          this.$store.dispatch('LOAD_ALL_FONTS');
          this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
      },
     mounted() {
          this.$store.dispatch('LOAD_ALL_FONTS');
          this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
     },

  watch: {
    productObject: {
      handler(newValue) {
        let toEmit = {...newValue}
        if(toEmit.enable_personalization === 'no') {
          toEmit.font_ids_enabled = []
          toEmit.designs = []
          toEmit.customer_design_upload_enabled = false
        }
        this.$emit('personalization', toEmit)
      },
      deep: true
    },
    product(newVal) {
      if(newVal) {
        this.productObject.enable_personalization = this.product.enable_personalization
        this.productObject.engraving_type = this.product.engraving_type
        this.productObject.personalization_type =  this.product.personalization_type.join(',')
        this.productObject.customer_design_upload_enabled =  this.product.customer_design_upload_enabled
        this.product.font_ids_enabled ? this.productObject.font_ids_enabled = this.product.font_ids_enabled.map(function(item) {
          return parseInt(item, 10);
        }) : this.productObject.font_ids_enabled = []
        this.product.designs ? this.productObject.design_ids = this.product.designs.map(function(item) { // todo rethink is this really needed
          return item.id // todo rethink is this really needed
        }) : this.productObject.design_ids = [] // todo rethink is this really needed
        this.productObject.designs = this.product.designs
        this.productObject.variants = this.product.variants
        this.productObject.printing_image = this.product.printing_image
        this.imagePreview = this.product.printing_image
        this.product.printing_image ? this.triggerMarker() : this.showMarker = false
        this.productObject.printing_image_height = this.product.printing_image_height
        this.productObject.printing_image_width = this.product.printing_image_width
        this.$refs.cropper.setCoordinates({
          width: this.product.printing_area_width,
          height: this.product.printing_area_height,
          left: this.product.printing_area_left,
          top: this.product.printing_area_top
        })
      }
    }
  }
}
</script>

<style lang="less">

    .image-personalization{
        border-radius: 3px;
        max-height: 600px;
        max-width: 600px;
        border: 2px dashed gray;
    }

    .table-scroll{
        max-height: 350px;
        overflow-y: scroll;
        background: ivory;
    }
    .image{
        max-width: 235px;
        max-height: 150px;
        margin-bottom: 5px;
        border-radius: 2px;
    }
    .add-button{
        margin-top: 13px;
    }

    .img-container {
      height: 250px;
    }

    .create-option-button {
      align-items: center;
      display: flex;
    }

    .option-title {
      display: flex;
      align-items: center;

      h5 {
        margin-right: 20px;
        margin-bottom: 0;
      }
    }

    .test {
      background: red;
    }

    .image-preview-container {
      max-width: 100%;
      height: auto;

      .image-preview {
        max-width: 100%;
        height: auto;
      }
    }
</style>
